<template>
  <div class="app-main" style="position: relative">
    <template v-if="existBusinessIntelligenceDashboard">
      <business-intelligence-dashboard :style="showBusinessIntelligenceDashboard ? '' : 'display: none !important'" />
    </template>
    <template v-if="existCargoInsurance">
      <cargo-insurance :style="showCargoInsurance ? '' : 'display: none !important'" />
    </template>
    <template v-if="existInsureList">
      <to-insure-page v-for="(item,index) in existInsureList" :key="index" :style="showToInsurePage(item) ? '' : 'display: none !important'" />
    </template>
    <template v-if="existJmReportList">
      <jm-report-iframe
        v-for="item in existJmReportList"
        :key="item.query.key"
        :report-path="item.query.reportPath"
        :style="showJmReportPage(item) ? '' : 'display: none !important'"
      />
    </template>
    <template>
      <keep-alive :include="[...cachedViews, homePageView]">
        <router-view v-if="!showBusinessIntelligenceDashboard && !showCargoInsurance && toShowInsurePage && toShowJmReportRouterView" ref="routerView" :key="key" />
      </keep-alive>
    </template>
    <!--遗留功能，待废弃-->
    <!--    <div v-show="$route.meta.showIframe" id="ifmReport1Div" style="width:100%;height: 100%" />-->
    <el-dialog
      :visible="ieTipVisible"
      append-to-body
      :show-close="false"
      custom-class="ieTip"
      width="960px"
    >
      <p style="font-size: 14px;">{{ $t('Message.DearUser') }}</p>
      <p>{{ $t('Message.ItSystemInOrderMode') }}</p>
      <p>{{ $t('Message.TheShownInTheBelow') }}</p>
      <img :src="ieTipImg">
      <p>{{ $t('Message.ToSwitchTutorialsSee') }}<el-link style="vertical-align: top" type="primary" href="https://cargoware.s2.udesk.cn/hc/articles/28724" target="_blank">https://cargoware.s2.udesk.cn/hc/articles/28724</el-link></p>
      <div slot="footer" style="text-align: center">
        <el-button type="primary" @click="ieTipVisible =false">{{ $t('Message.GotIt') }}</el-button>
      </div>
    </el-dialog>
    <!--沃宝-->
    <div
      ref="expandDiv"
      style="position: absolute; bottom:50px; right: 14px; z-index: 900; width: 350px!important;"
    >
      <!--沃宝信息-->
      <div
        v-show="showWoBaoInfo"
        style="display: flex; flex-direction: column; background-color: #FFFFFF; padding: 10px 10px; height: 270px;"
      >
        <!--上层内容：-->
        <div style="display: flex; flex-direction: row; gap: 10px">
          <!--左边-->
          <div style="display: flex; flex-direction: row; gap: 10px">
            <!--左边图标-->
            <img src="@/assets/icons/wobao.png" style="width: 75px; height: 60px">
            <!--右边：上面分类，下面标题-->
            <div
              style="display: flex; flex-direction: column; width: 155px; gap: 5px; padding-top: 10px; justify-content:space-between"
            >
              <span
                style="color: #E57975; font-weight: bold; font-size: 14px; cursor: pointer"
                @click="clickOpenSysMsg"
              >{{
                $t('SystemMaintenance.TodayUnReadMsg') + '（' + (woBaoInfo.number || 0) + '）'
              }}</span>
              <span
                style="color: #555555; font-weight: bold; font-size: 14px; padding-bottom: 0;overflow: hidden;text-overflow: ellipsis;display: -webkit-box;-webkit-line-clamp: 2; -webkit-box-orient: vertical;"
              >
                {{ woBaoInfo.info.topic || '' }}
              </span>
            </div>
          </div>
          <!--右边-->
          <div
            style="display: flex; flex-direction: column; align-items: flex-end; width: 65px; justify-content:space-between;"
          >
            <i class="el-icon-close" style="font-size: 20px" @click="clickWoBaoInfoClose" />
            <span>{{ this.convertNotifyDateToHHmm() }} </span>
          </div>
        </div>
        <!--下层内容：消息体内容-->
        <div style="width: 320px; height: 200px; position: relative;">
          <p v-html="woBaoInfo.info.content" />
          <el-button
            v-show="woBaoInfo.info && woBaoInfo.info.link"
            type="success"
            style="float:right; position: absolute; bottom: 5px; right: 5px;"
            @click="btnShowDetailHandler(woBaoInfo.info)"
          >{{ $t('CargoMsg.Cargo_LookDetail') }}
          </el-button>
        </div>
      </div>
    </div>

    <!--沃宝图标-->
    <div
      v-show="showWoBaoIcon"
      style="position: absolute; bottom:50px; right: 14px; z-index: 900; display: flex; flex-direction: column; align-items: flex-end; justify-content: flex-end;"
      @mouseenter="showCloseText = true"
      @mouseleave="showCloseText = false"
    >
      <span
        v-if="showCloseText"
        class="close-text"
        @click="clickWoBaoIconCloseText"
      >{{ $t('CargoMsg.Cargo_DisableOpen') }}</span>
      <img src="@/assets/icons/wobao.png" style="margin-right: 0;" draggable="false" @click="clickWoBaoIcon">
    </div>
  </div>
</template>

<script>
import { ErrorTip } from '@/utils/class/ErrorTip'
import ieTipImg from '@/assets/ie-tip.png'
import { matchView, refreshView } from '@/store/modules/tagsView'
import BusinessIntelligenceDashboard from '@/views/cargo/v0/BiAnalysis/businessIntelligenceDashboard'
import { getLangMetaTitle } from '@/utils/langUtil'
import CargoInsurance from '@/views/cargo/v0/Insurance/cargoInsurance'
import ToInsurePage from '@/views/cargo/v0/Insurance/components/toInsurePage'
import JmReportIframe from '@/views/cargo/v0/JmReport/jmReportIframe'
import { getWoBaoRemind, getWoBaoState, unSubscribeWoBao } from '@/api/messageNotify'
import moment from 'moment'
import { getCargoJumpUrl } from '@/utils/permission'
import { MsgNotifyConstants as MsgNotify } from '@/components/Cargo/Common/SysMessage/components/MsgNotifyConstants'
import { mapGetters } from 'vuex'
import { cache, cacheName } from '@/utils/cacheManager'
import { activeUser, getCargoAllUser } from '@/api/user'
import URL from '@/api/urlTranslator'

export default {
  name: 'AppMain',
  components: { JmReportIframe, ToInsurePage, CargoInsurance, BusinessIntelligenceDashboard },
  data() {
    return {
      view: {},
      ieTipImg,
      ieTipVisible: false,
      showCloseText: false,
      showWoBaoInfo: false,
      showWoBaoIcon: false,
      woBaoTimeoutId: null,
      woBaoInfo:
        {
          number: '',
          info: {
            'acrossTenant': '',
            'actionCode': '',
            'classifyCode': '',
            'content': '',
            'createdBy': '',
            'dateCreated': '',
            'dateModified': '',
            'modifiedBy': '',
            'notifyDate': '',
            'readed': '',
            'receiver': '',
            'sender': '',
            'target': '',
            'targetType': '',
            'tenantId': '',
            'topic': '',
            'type': '',
            'uuid': '',
            'version': '',
            'visible': '',
            'link': ''
          }
        },
      MsgNotifyConstants: new MsgNotify(),
      storageURL: '',
      homePageView: '' // 首页视图
    }
  },
  errorCaptured(err) {
    if (err instanceof ErrorTip) {
      this.$message(err)
      return false
    }
    return true
  },
  // 进来查询数据和
  async beforeMount() {
    // 加载配置
    await cache.load(cacheName.CONFIG)
    this.storageURL = cache.config.get('StorageURL')
  },
  computed: {
    isZh() {
      return this.$store.getters.language === 'zh'
    },
    cachedViews() {
      return this.$store.state.tagsView.cachedViews
    },
    key() {
      let result = this.$route.path
      const query = this.$route.query
      if (query.openNew && query.key) {
        result += `&key=${query.key}`
      }
      if (this.view.r > 0) {
        result += `&r=${this.view.r}`
      }
      return result
    },
    // 是否存在数据驾驶舱页签
    existBusinessIntelligenceDashboard() {
      return this.$store.state.tagsView.visitedViews.find(v => v.name === 'BusinessIntelligenceDashboard')
    },
    // 是否显示数据驾驶舱页签
    showBusinessIntelligenceDashboard() {
      return this.$route.name === 'BusinessIntelligenceDashboard'
    },
    // 是否存在货运险页签
    existCargoInsurance() {
      return this.$store.state.tagsView.visitedViews.find(v => v.name === 'CargoInsurance')
    },
    // 是否显示货运险页签
    showCargoInsurance() {
      return this.$route.name === 'CargoInsurance'
    },
    // 是否投保页签
    existInsureList() {
      const list = []
      for (const v of this.$store.state.tagsView.visitedViews) {
        if (v.name === 'ToInsurePage') {
          list.push(v)
        }
      }
      return list
    },
    existJmReportList() {
      const list = []
      for (const v of this.$store.state.tagsView.visitedViews) {
        if (v.name === 'JmReport' && v.query && v.query.reportPath) {
          list.push(v)
        }
      }
      return list
    },
    // 若是投保页面跳转
    toShowInsurePage() {
      const isShow = true
      for (const item of this.existInsureList) {
        if (this.$route.name === 'ToInsurePage' && this.$route.query.key === item.query.key) {
          return false
        }
      }
      return isShow
    },
    toShowJmReportRouterView() {
      if (this.$route.name === 'JmReport' && this.$route.query && this.$route.query.reportPath) {
        return false
      }
      return true
    },
    ...mapGetters([
      'currentOfficeId',
      'tenantId',
      'userInfo'
    ]),
    routes() {
      return this.$store.state.permission.routes
    }
  },
  watch: {
    $route() {
      this.view = this.getView()
      if (this.view.meta) {
        document.title = getLangMetaTitle(this.view.meta)
      }
    },
    '$store.state.bellNotify.woBaoShow': {
      handler(value) {
        if (value) {
          // 设置弹窗为true
          this.showWoBaoInfo = true
          // 先查询一次拿到信息
          this.getWoBaoRemind(true)
          // 设置一个定时器
          this.setWoBaoTimeout()
        } else {
          this.showWoBaoInfo = false
          this.showWoBaoIcon = false
          // 清除定时器
          clearInterval(this.woBaoTimeoutId)
        }
      }
    }
  },
  mounted() {
    document.body.ondrop = function(event) {
      event.preventDefault(); event.stopPropagation()
    }
    if (this.isIE()) {
      this.ieTipVisible = true
    }
    this.view = this.getView()
    if (this.view.meta) {
      document.title = getLangMetaTitle(this.view.meta)
    }
    /* 解决首次进入页面不执行activated问题 */
    if (this.$refs.routerView) {
      this.triggerActivated(this.$refs.routerView)
    }
    //  进来查询最新消息
    this.woBaoHandle()
    // 校验用户能否登录
    if (this.checkUserCanLogin()) {
      // 校验可用用户数
      this.checkAvailableUserCount()
    }
    this.homePageView = 'Dashboard' // 首页视图
  },
  methods: {
    checkUserCanLogin() {
      if (this.$store.getters.userInfo.isDisableLogin) {
        this.$confirm('<span style="color: darkred;">' + this.$t('SystemMaintenance.NotLoginUserContactAdmin') + '</span>', this.$t('SystemMaintenance.Prompt'), {
          confirmButtonText: this.$t('common.btn.ok'),
          dangerouslyUseHTMLString: true,
          showCancelButton: false,
          closeOnClickModal: false,
          showClose: false,
          closeOnPressEscape: false,
          type: 'warning'
        }).then(async() => {
          this.$store.dispatch('tagsView/delAllViews').then(() => {
            return this.$store.dispatch('user/logout')
          }).then(() => {
            this.$router.push('/login')
          }).catch(() => {
            location.reload()
          })
        }).catch(() => {})
        return false
      }
      return true
    },
    async checkAvailableUserCount() {
      const { userCountLimited, initUserCount, validUserCount } = this.$store.state.settings.bsLimitInfo
      if (userCountLimited && validUserCount >= 0) {
        let activeUserCount = 0
        const userList = await getCargoAllUser().then(res => res.data)
        if (userList && userList.length > 0) {
          for (const p of userList) {
            if (p.active && !p.isDisableLogin) {
              activeUserCount = activeUserCount + 1
            }
          }
        }
        if (activeUserCount > initUserCount + validUserCount) {
          if (this.$store.getters.isAdmin) {
            this.$confirm(this.$t('SystemMaintenance.UserCountExpireLimitAdmin'), this.$t('SystemMaintenance.Prompt'), {
              confirmButtonText: this.$t('common.btn.ok'),
              dangerouslyUseHTMLString: true,
              showCancelButton: false,
              closeOnClickModal: false,
              showClose: false,
              closeOnPressEscape: false,
              type: 'warning'
            }).catch(() => {})
            return
          }
          this.$confirm(this.$t('SystemMaintenance.UserCountExpireLimitUse'), this.$t('SystemMaintenance.Prompt'), {
            confirmButtonText: this.$t('common.btn.ok'),
            dangerouslyUseHTMLString: true,
            showCancelButton: false,
            closeOnClickModal: false,
            showClose: false,
            closeOnPressEscape: false,
            type: 'warning'
          }).then(async() => {
            if (!this.$store.getters.isAdmin) {
              await activeUser({ active: 0, userIds: `${this.$store.getters.userId}` })
            }
            this.$store.dispatch('tagsView/delAllViews').then(() => {
              return this.$store.dispatch('user/logout')
            }).then(() => {
              this.$router.push('/login')
            }).catch(() => {
              location.reload()
            })
          }).catch(() => {})
        }
      }
    },
    isIE() {
      const userAgent = navigator.userAgent // 取得浏览器的
      console.log(userAgent)
      return userAgent.indexOf('Trident') > -1 || navigator.userAgent.indexOf('Edge') > -1
    },
    getView() {
      const view = this.$store.state.tagsView.visitedViews.find(v => matchView(v, this.$route))
      if (view) {
        if (!view.instance) {
          this.$nextTick(() => {
            view.instance = this.$refs.routerView
          })
        }
        return view
      } else {
        return {}
      }
    },
    triggerActivated(instance) {
      const instances = this.getAllComponentInstances(instance)
      for (const item of instances) {
        const options = Object.getPrototypeOf(item.$options)
        if (options.activated && options.activated.length > 0) {
          const oldActivated = item.activated // 记录旧的属性，避免覆盖
          item.activated = options.activated[0]
          item.activated()
          if (typeof oldActivated !== 'undefined') {
            item.activated = oldActivated
          } else {
            delete item.activated
          }
        }
      }
    },
    getAllComponentInstances(instance, result = []) {
      result.push(instance)
      if (instance.$children instanceof Array) {
        for (const item of instance.$children) {
          this.getAllComponentInstances(item, result)
        }
      }
      return result
    },
    // 是否显示货运险页签
    showToInsurePage(curRoute) {
      return this.$route.name === 'ToInsurePage' && this.$route.query.key === curRoute.query.key
    },
    showJmReportPage(curRoute) {
      return this.$route.name === 'JmReport' && this.$route.query.key === curRoute.query.key
    },
    // 点击沃宝图标动作
    clickWoBaoIcon() {
      this.showWoBaoIcon = false
      this.showWoBaoInfo = true
    },
    // 点击沃宝图标的关闭文字动作
    clickWoBaoIconCloseText() {
      this.showWoBaoIcon = false
      this.showWoBaoInfo = false
      // 取消沃宝的关注
      this.unSubscriptionWoBao()
      // 清除定时器
      clearInterval(this.woBaoTimeoutId)
    },
    // 点击沃宝信息的X动作
    clickWoBaoInfoClose() {
      this.showWoBaoIcon = true
      this.showWoBaoInfo = false
    },
    // 点击"今日未读消息" 打开铃铛消息页面
    clickOpenSysMsg() {
      // 触发父组件的事件
      this.$emit('openSysMsg')
    },
    // 获取沃宝的动作
    woBaoHandle() {
      // 获取沃宝的订阅状态
      getWoBaoState().then(resp => {
        // 订阅状态才继续查询沃宝的信息
        if (resp.data) {
          // 设置弹窗为true
          this.showWoBaoInfo = true
          // 先查询一次拿到信息
          this.getWoBaoRemind(true)
          // 设置一个新的定时器,每隔十分钟执行一次查询最新的信息
          if (!this.woBaoTimeoutId) {
            this.setWoBaoTimeout()
          }
        }
      })
    },
    setWoBaoTimeout() {
      this.woBaoTimeoutId = setInterval(() => {
        // 超过10分钟后调用接口
        this.getWoBaoRemind(false)
      }, 10 * 60 * 1000)
    },
    // 查询沃宝的最新信息
    getWoBaoRemind(flag) {
      getWoBaoRemind(this.getTodayDateRange()).then(resp => {
        if (resp.data) {
          // 第二次调用将判断数据是否一致，进行弹窗的设置
          if (!flag && resp.data.info.uuid !== this.woBaoInfo.info.uuid) {
            this.showWoBaoIcon = false
            this.showWoBaoInfo = true
          }
          // 第一次调用直接赋值
          this.woBaoInfo = resp.data
          this.filter([this.woBaoInfo.info])
        }
      })
    },
    // 取消关注沃宝
    unSubscriptionWoBao() {
      // 调用接口
      unSubscribeWoBao().then(resp => {
        if (resp.data && resp.data > 0) {
          this.$message.success(this.$t('CargoMsg.Cargo_OperationSuccessfully'))
        } else {
          this.$message.warning(this.$t('SeaExport.OperationFailed'))
        }
      })
    },
    // 获取今天的时间范围
    getTodayDateRange() {
      // 使用 moment.js 获取当前日期
      const today = moment().format('YYYY-MM-DD').toString()
      // 将两个日期放入数组中
      return [today + ' 00:00:00', today + ' 23:59:59']
    },
    // 将收到通知的时间改为HH:mm的格式
    convertNotifyDateToHHmm() {
      if (this.woBaoInfo.info.notifyDate) {
        // 原始日期字符串
        const dateString = this.woBaoInfo.info.notifyDate

        // 使用Date对象解析日期字符串
        const date = new Date(dateString)

        // 获取小时和分钟，并确保它们是两位数字的格式
        const hours = String(date.getHours()).padStart(2, '0')
        const minutes = String(date.getMinutes()).padStart(2, '0')

        // 组合成新的格式"HH:mm"
        return `${hours}:${minutes}`
      } else {
        return ''
      }
    },
    btnShowDetailHandler(data) {
      // 获取跳转页签的父类菜单，看是否有权限
      const routeModel = this.getParentModel(data.actionCode)
      const parentRoute = this.routes.find(item => item.module === routeModel)
      if (!routeModel) {
        this.$message.warning(this.$t('Sop.hasPermission'))
        return
      }
      if (!parentRoute) {
        return
      }
      const actionCode = data.link
      if (!actionCode) {
        return
      }
      // 获取子菜单
      const menu = parentRoute.children.find(item => item.module === actionCode)
      if (!menu) {
        return
      }
      if (this.isJumpCargo(menu)) {
        const jumpCargoUrl = getCargoJumpUrl({
          code: actionCode,
          language: this.language,
          sessionId: this.userInfo.sessionId,
          branchId: this.currentOfficeId,
          departmentId: this.currentDeptId
        })
        window.open(jumpCargoUrl, '_blank')
      } else {
        if (data.actionCode === 'CHARGE_CHANGE_NOTICE_SE') {
          this.toLink(menu.name, { jobUuid: data.target, activeTabName: 'tabCharges' })
        } else if (data.actionCode === 'CHARGE_CHANGE_NOTICE_AE') {
          this.toLink(menu.name, { jobUuid: data.target, activeTabName: 'tabCharges' })
        } else {
          this.toLink(menu.name)
        }
      }
    },
    // 是否跳转cargo
    isJumpCargo(item) {
      const user = this.$store.state.user
      // 根据当前分公司判断菜单是否开启跳转H5功能
      if (user && user.menuInfo && user.menuInfo.tenantOfficeMenus) {
        const tenantOfficeMenus = user.menuInfo.tenantOfficeMenus
        const officeUuid = this.$store.getters.currentOfficeUuid
        if (tenantOfficeMenus) {
          for (const tenantOfficeMenu of tenantOfficeMenus) {
            if (item.uuid && item.uuid === tenantOfficeMenu.menuUuid && officeUuid && officeUuid === tenantOfficeMenu.officeUuid) {
              return !tenantOfficeMenu.openH5Url
            }
          }
        }
      }
      return item.jumpCargo
    },
    toLink(name, params = {}) {
      const oldRoute = this.$route
      this.$router.push({ name, params })
      // 路由无变化，手动刷新
      if (this.$route === oldRoute) {
        const view = this.$store.state.tagsView.visitedViews.find(v => matchView(v, this.$route))
        Object.assign(view.params, params)
        refreshView(view)
      }
    },
    getParentModel(actionCode) {
      if (actionCode === 'Combine_charge_item') { // 收费项目
        return 'basicInfo'
      } else if (actionCode === 'IMPORT_ORDER_SE' || actionCode === 'CHARGE_CHANGE_NOTICE_SE') {
        return 'SEAEXPORT'
      } else if (actionCode === 'IMPORT_ORDER_SI') {
        return 'SEAIMPORT'
      } else if (actionCode === 'IMPORT_ORDER_AE' || actionCode === 'CHARGE_CHANGE_NOTICE_AE') {
        return 'AIREXPORT'
      } else if (actionCode === 'IMPORT_ORDER_AI') {
        return 'AIRIMPORT'
      } else if (actionCode === 'IMPORT_ORDER_RE') {
        return 'RAILWAYEXPORT'
      } else if (actionCode === 'IMPORT_ORDER_RI') {
        return 'RAILWAYEXPORT'
      } else if (actionCode === 'IMPORT_ORDER_FBA_SE' || actionCode === 'IMPORT_ORDER_FBA_AE' || actionCode === 'IMPORT_ORDER_FBA_RE' || actionCode === 'IMPORT_ORDER_FBA') {
        return 'FBA'
      } else if (actionCode === 'IMPORT_ORDER_FAILD') {
        return 'Files'
      } else { // 运价
        return 'Freight Rate'
      }
    },
    filter(list) {
      return list.map(item => {
        if (item.actionCode === this.MsgNotifyConstants.FILE_EXPORT_FINISHED.actionCode || item.actionCode === this.MsgNotifyConstants.PRICE_AUDIT_EVENT_FCL.actionCode) {
          item.content = (moment(item.notifyDate).format(this.$t('Message.MMDDDayHHMm'))) + '<br>' + item.content
          item.content = item.content.replace('javascript:void(0)', `${URL.common.findByFileId}/${item.target}?sessionId=${this.userInfo.sessionId}`)
        } else {
          if (item.content) {
            item.content = (moment(item.notifyDate).format(this.$t('Message.MMDDDayHHMm'))) + '    ' + item.content.replace(/size=\'12\'/g, '')
          }
        }
        return item
      })
    },
    // 沃宝图标移动方法
    onMousedown(e) {
      const expandDiv = this.$refs.expandDiv
      expandDiv.style.cursor = 'move'
      const disX = e.pageX - expandDiv.offsetLeft
      const disY = e.pageY - expandDiv.offsetTop
      document.onmousemove = globalEvent => {
        expandDiv.style.left = globalEvent.pageX - disX + 'px'
        expandDiv.style.top = globalEvent.pageY - disY + 'px'
      }
    },
    onMouseUp() {
      const expandDiv = this.$refs.expandDiv
      expandDiv.style.cursor = 'default'
      document.onmousemove = document.onmouseup = null
    }
  }
}
</script>

<style lang="scss">
.app-main {
  /* 50= navbar  50  */
  flex: 1;
  display: flex;
  flex-direction: column;
  position: relative;
  overflow: hidden;
}

.fixed-header+.app-main {
  padding-top: 50px;
}

.hasTagsView {
  /*.app-main {
    !* 84 = navbar + tags-view = 50 + 34 *!
    min-height: calc(100vh - 84px);
  }*/

  .fixed-header+.app-main {
    padding-top: 84px;
  }
}
</style>
<style lang="scss">
// fix css style bug in open el-dialog
.el-popup-parent--hidden {
  .fixed-header {
    padding-right: 15px;
  }
}
.ieTip{
&.el-dialog {
  .el-dialog__header{
    padding: 0!important;
    border:none!important;
  }
  .el-dialog__footer{
    border: none!important;
    padding: 0 0 10px 0!important;
  }
  p{
    color: #333!important;
  }
}
}
.app-main {
  .close-text {
    bottom: 10px;
    left: 10px;
    font-size: 15px;
    width: 100px;
    text-align: center;
    cursor: pointer;
  }
}
</style>
